import { defineMessages } from 'react-intl-next';

export const messages: {
	chatInputActionsButtonsTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionTypeAheadButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkTypeAheadButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addContentButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addMoreFormattingButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addCurrentPageAsContextDisabledTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	discoverSkillsButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	discoverSkillsButtonDisabledTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	browsePromptLibraryButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	chatInputActionsButtonsTooltip: {
		id: 'ai-mate.chat-input.open-chat-input-buttons-tooltip',
		defaultMessage: 'Add',
		description: 'Tooltip for Add a resource menu button',
	},
	mentionTypeAheadButtonLabel: {
		id: 'ai-mate.chat-input.mention-type-ahead-button.label',
		defaultMessage: 'Mention someone',
		description: 'Label for the mention type ahead button',
	},
	linkTypeAheadButtonLabel: {
		id: 'ai-mate.chat-input.link-type-ahead-button.label',
		defaultMessage: 'Add a link',
		description: 'Label for the link type ahead button',
	},
	addContentButtonLabel: {
		id: 'ai-mate.chat-input.add-content-button.label',
		defaultMessage: "Use what you're viewing as context",
		description: 'Label for the add current page as context button',
	},
	addMoreFormattingButtonLabel: {
		id: 'ai-mate.chat-input.add-more-formatting-button.label',
		defaultMessage: 'More formatting',
		description: 'Label for the more formatting button',
	},
	addCurrentPageAsContextDisabledTooltip: {
		id: 'ai-mate.chat-input.add-current-page-as-context-disabled-tooltip',
		defaultMessage: "This page isn't supported yet",
		description: 'Tooltip for the add current page as context button when disabled',
	},
	discoverSkillsButtonLabel: {
		id: 'ai-mate.chat-input.discover-skills-button.label',
		defaultMessage: 'View all skills',
		description: 'Label for the view all skills button',
	},
	discoverSkillsButtonDisabledTooltip: {
		id: 'ai-mate.chat-input.discover-skills-button.disabled-tooltip',
		defaultMessage: "You're already using a skill",
		description:
			'Tooltip for the discover skills button when disabled because a skill is already in the prompt',
	},
	browsePromptLibraryButtonLabel: {
		id: 'ai-mate.chat-input.browse-prompt-library-button.label',
		defaultMessage: 'Browse Prompt library',
		description: 'Label for the browse prompt library button',
	},
});
